import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import VehicleTypesList from './VehicleTypesList'

export default function VehicleTypes() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/vehicle_types" component={VehicleTypesList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}